import StickyFiltersMixin from '@/mixins/stickyFilters'
import { sortBy } from 'lodash'

export default {
  mixins: [StickyFiltersMixin],
  data () {
    return {
      marginTop: 120,
      marginBottom: 170,
      lastScrollTop: 0
    }
  },
  methods: {
    computeFiltersTop () {
      let scrollTop = document.documentElement.scrollTop
      let header = document.querySelector('.header-wrapper__inner')
      let headerTop = header.getBoundingClientRect().top
      let headerHeight = header.offsetHeight
      let filtersHeight = document.querySelector('#filter-options')?.clientHeight ?? 0
      let windowHeight = document.documentElement.clientHeight
      let maxTop = Math.max(...[headerHeight + headerTop + this.marginTop, this.marginTop])
      let minTop = maxTop - (Math.max(filtersHeight - windowHeight, -this.marginBottom) + this.marginBottom)
      let scrollDiff = scrollTop - this.lastScrollTop
      let newTop = this.filtersOffset.top - scrollDiff

      this.filtersOffset.top = sortBy([minTop, newTop, maxTop], e => e)[1]
      this.lastScrollTop = scrollTop
    }
  }
}
